import React, { useEffect, useState } from 'react';
import { ContextualMenu, ContextualMenuItemProps } from '@europrocurement/flexy-components';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { DossierArticle } from '../../hooks';

export type DossierArticleProcessMenuItemProps = {
    label: string;
    icon: IconName;
    onClick: (article: DossierArticle) => void;
};

export type DossierArticleProcessMenuProps = {
    article: DossierArticle;
    getItemActions?: (article: DossierArticle) => Array<DossierArticleProcessMenuItemProps>;
};

const DossierArticleProcessMenu: React.FunctionComponent<DossierArticleProcessMenuProps> =
    function ({ article, getItemActions = () => [] }) {
        const [menuItems, setMenuItems] = useState<ContextualMenuItemProps[]>([]);

        useEffect(() => {
            const actions = getItemActions(article);
            setMenuItems(
                actions.map((action) => ({
                    label: action.label,
                    icon: action.icon,
                    onClick: () => action.onClick(article),
                })),
            );
        }, [article, getItemActions]);

        return (
            <ContextualMenu
                items={menuItems}
                buttonSx={{ padding: 0 }}
            />
        );
    };

export default DossierArticleProcessMenu;
